import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import api from '../../api/auth';

const Exams = () => {
  const { user } = useAuth();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await api.get('/parent/exams', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setExams(response.data);
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-[#2C3E50]">📝 Compositions</h1>
      <p className="text-gray-500">Consultez les compositions à venir</p>

      {loading ? (
        <div className="text-center py-8">Chargement...</div>
      ) : exams.length === 0 ? (
        <div className="bg-white rounded-xl shadow-md p-8 text-center">
          <p className="text-gray-500">Aucune composition</p>
        </div>
      ) : (
        <div className="space-y-4">
          {exams.map((exam) => (
            <div key={exam.id} className="bg-white rounded-xl shadow-md p-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-semibold text-[#2C3E50]">{exam.title}</h3>
                  <p className="text-sm text-gray-500">{exam.subject} - {exam.class_name}</p>
                  <p className="text-sm text-gray-500">📅 {exam.date} ⏰ {exam.time}</p>
                  <p className="text-sm text-gray-500">📍 Salle {exam.room}</p>
                  {exam.topics && (
                    <p className="text-sm text-gray-600 mt-1">📌 Programme: {exam.topics}</p>
                  )}
                </div>
                <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                  À venir
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Exams;